import gallery1 from "./Images/gallery1.jpeg";
import gallery2 from "./Images/gallery2.jpeg";
import gallery3 from "./Images/gallery3.jpeg";
import gallery4 from "./Images/gallery4.jpeg";
import gallery5 from "./Images/gallery5.jpeg";
import gallery6 from "./Images/gallery6.jpeg";

// import galleryModel from "./galleryJSON.json"

function GalleryPage(){
    return(
        <>
            <div className="container">
                <div className="row">
                    <h1 className="text-center display-3 my-3 headingCls">GALLERY</h1>
                </div>
                {/* <!-- Gallery --> */}
                <div className="row">
                    <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={gallery1}
                        className="w-100 shadow-1-strong rounded border border-3 border-dark mb-4"
                        alt="Boat on Calm Water" data-bs-toggle="modal" data-bs-target="#image1"
                    />
                
                    <img
                        src={gallery2}
                        className="w-100 shadow-1-strong rounded border border-3 border-dark mb-4"
                        alt="Wintry Mountain Landscape" data-bs-toggle="modal" data-bs-target="#image2"
                    />
                    </div>
                
                    <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={gallery3}
                        className="w-100 shadow-1-strong rounded border border-3 border-dark mb-4"
                        alt="Mountains in the Clouds" data-bs-toggle="modal" data-bs-target="#image3"
                    />
                
                    <img
                        src={gallery4}
                        className="w-100 shadow-1-strong rounded border border-3 border-dark mb-4"
                        alt="Boat on Calm Water" data-bs-toggle="modal" data-bs-target="#image4"
                    />
                    </div>
                
                    <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={gallery5}
                        className="w-100 shadow-1-strong rounded border border-3 border-dark mb-4"
                        alt="Waves at Sea" data-bs-toggle="modal" data-bs-target="#image5"
                    />
                
                    <img
                        src={gallery6}
                        className="w-100 shadow-1-strong rounded border border-3 border-dark mb-4"
                        alt="Yosemite National Park" data-bs-toggle="modal" data-bs-target="#image6"
                    />
                    </div>
                </div>
                {/* <!-- Gallery --> */}
            </div>
        
            {/* {galleryModel.filter().map((record)=>{
                return(
                    <>
                        <div className="modal fade" id={record.id} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                <img src={record.pic} alt="" className="img-fluid w-100"/>
                                </div>
                            </div>
                            </div>
                        </div>
                    </>
                )
            })} */}

            {/* <!-- Modal1 --> */}
            <div className="modal fade" id="image1" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                    <img src={gallery1} alt="" className="img-fluid w-100"/>
                    </div>
                </div>
                </div>
            </div>
            {/* <!-- Modal2 --> */}
            <div className="modal fade" id="image2" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                    <img src={gallery2} alt="" className="img-fluid w-100"/>
                    </div>
                </div>
                </div>
            </div>
            {/* <!-- Modal3 --> */}
            <div className="modal fade" id="image3" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <img src={gallery3} alt="" className="img-fluid w-100"/>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Modal4 --> */}
            <div className="modal fade" id="image4" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                    <img src={gallery4} alt="" className="img-fluid w-100"/>
                    </div>
                </div>
                </div>
            </div>
            {/* <!-- Modal5 --> */}
            <div className="modal fade" id="image5" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <img src={gallery5} alt="" className="img-fluid w-100"/>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Modal6 --> */}
            <div className="modal fade" id="image6" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                    <img src={gallery6} alt="" className="img-fluid w-100"/>
                    </div>
                </div>
                </div>
            </div>
        </>
    )
}export default GalleryPage